<template>
  <div class="creative-title-wrap">
    <div class="card-header">
      创意标题<span class="num-text">{{ dataList.length }}/10</span>
      <div class="btn-group">
        <el-button icon="el-icon-plus" type="text" @click="addTitle"
          >新增</el-button
        ><span class="center-line"></span>
        <el-button icon="el-icon-plus" type="text" @click="selectTitle"
          >选择已有</el-button
        >
      </div>
    </div>
    <div class="card-list">
      <card-item
        v-for="item of dataList"
        :key="item.itemId"
        :title="item.titlePkgName"
        :dataSet="item"
        @edit="editCreativeTitle"
        @copy="copyCreativeTitle"
        @del="delCreativeTitle"
        :isCur="curItem.itemId === item.itemId"
        :showDelete="dataList.length > 1"
      ></card-item>
    </div>
    <div class="add-modal-body">
      <div class="modal-content">
        <el-form
          ref="titleFormRef"
          :model="curItem"
          :rules="rules"
          label-width="90px"
        >
          <el-form-item label="标题包名称:" prop="titlePkgName">
            <el-input
              v-model="curItem.titlePkgName"
              placeholder="请输入标题包名称"
            ></el-input>
          </el-form-item>
          <div class="word-list-wrap">
            <div
              class="form-wrap"
              v-for="(item, index) of curItem.dataStrList"
              :key="item.dataId"
            >
              <div class="form-header">
                <span class="header-text">标题</span>
                <el-button
                  type="text"
                  icon="el-icon-plus"
                  @click="openWordModal(index)"
                  :disabled="item.wordNum && item.wordNum >= 2 ? true : false"
                  >插入动态词包</el-button
                ><span class="center-line"></span
                ><i
                  class="el-icon-delete del-icon"
                  @click="delTitleItem(index)"
                ></i>
              </div>
              <div class="form-content">
                <el-input
                  type="textarea"
                  placeholder="标题长度范围5-30个字"
                  v-model="item.value"
                  resize="none"
                  @input="(data) => checkWordLength(data, index)"
                >
                </el-input>
              </div>
            </div>
          </div>
          <el-button icon="el-icon-plus" class="add-icon" @click="addTitleItem"
            >添加创意标题</el-button
          >
        </el-form>
      </div>
      <span slot="footer" class="footer-wrap">
        <el-button @click="saveCreativeTitle" type="primary"
          >保存到标题包</el-button
        >
        <!-- <el-button type="primary" @click="saveInStore">确 定</el-button> -->
      </span>
    </div>

    <!-- 动态词包 -->
    <el-dialog
      title="添加标题包"
      :visible.sync="showWordModal"
      width="764px"
      :close-on-click-modal="false"
    >
      <div class="word-modal-body">
        <div class="modal-content">
          <el-table :data="wordList" style="width: 100%" height="400px">
            <el-table-column prop="name" label="词包名"></el-table-column>
            <el-table-column label="替换词" width="200">
              <template slot-scope="scope">
                <div class="wordlist-wrap">
                  {{ scope.row.words.join() }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="max_word_len"
              label="最大长度"
            ></el-table-column>
            <el-table-column label="用户覆盖率">
              <template slot-scope="scope">
                {{
                  String((scope.row.user_rate * 100).toFixed(2)).replace(
                    /.00$/,
                    ""
                  )
                }}%
              </template>
            </el-table-column>
            <el-table-column
              prop="default_word"
              label="默认词"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click="insertData(scope.row)"
                  >插入</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <!-- 选择已有 -->
    <checked-modal
      title="选择标题包"
      :tableConf="tableConf"
      :tableData="tableData"
      ref="checkedModalRef"
      @selectOk="selectOk"
    ></checked-modal>
  </div>
</template>

<script>
import {
  getCreativeWord,
  saveCreativeTitle,
  queryCreativeTitle,
} from "@/api/promotion-kuaishou.js";
import CheckedModal from "./common/checkedModal.vue";
import CardItem from "./common/cardItem.vue";
import { mapState } from "vuex";
export default {
  components: {
    CardItem,
    CheckedModal,
  },
  data() {
    return {
      tableConf: [
        { title: "标题包名称", colName: "titlePkgName" },
        { title: "创建时间", colName: "createTimeStr" },
      ],
      tableData: [],
      showWordModal: false,
      dataList: [],
      wordList: [],
      curWordIndex: 0, //当前编辑的词包的标题序号
      curItem: {},
      rules: {
        titlePkgName: [
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (this.curItem.titlePkgName === "") {
                callback(new Error("标题包名称必填"));
              } else if (this.curItem.dataStrList.length <= 0) {
                callback(new Error("该标题包未添加标题包"));
              } else {
                let isNoData = this.curItem.dataStrList.some(
                  (item) => item.value === ""
                );
                if (isNoData) {
                  callback(new Error("该标题包有部分未添加数据"));
                } else {
                  callback();
                }
              }
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.selectWordList();
    this.addTitle();
  },
  methods: {
    addTitle() {
      if (this.dataList.length >= 10) {
        return;
      }
      this.dataList.push({
        itemId: Math.random(),
        titlePkgName: "创意标题" + (this.dataList.length + 1),
        dataStrList: [
          {
            dataId: Math.random(),
            wordNum: 0, //动态词个数
            value: "",
          },
        ],
      });
      this.saveInStore();
    },
    selectTitle() {
      this.$refs.checkedModalRef.showModal();
      //查询预算包
      queryCreativeTitle().then((res) => {
        if (res.code === "0000") {
          this.tableData = res.creativeTitles;
        }
      });
    },
    selectOk(dataList) {
      dataList.forEach((checkedItem) => {
        let formItem = {
          itemId: Math.random(),
          titlePkgName: checkedItem.titlePkgName,
          dataStrList: JSON.parse(checkedItem.title_data).title_list.map(
            (wordItem) => {
              return {
                dataId: Math.random(),
                wordNum: wordItem.title.match(/{(.*?)}/g)
                  ? wordItem.title.match(/{(.*?)}/g).length
                  : 0, //动态词个数
                value: wordItem.title,
              };
            }
          ),
        };
        this.dataList.push(formItem);
      });
      this.saveInStore();
    },
    addTitleItem() {
      if (this.curItem.dataStrList.length > 2) {
        return;
      } else {
        this.curItem.dataStrList.push({
          dataId: Math.random(),
          wordNum: 0, //动态词个数
          value: "",
        });
      }
    },
    delTitleItem(index) {
      this.curItem.dataStrList.splice(index, 1);
    },
    openWordModal(index) {
      this.curWordIndex = index;
      this.showWordModal = true;
    },
    selectWordList() {
      getCreativeWord().then((res) => {
        if (res.code === "0000") {
          this.wordList = res.creativeWordList.map((item) => {
            //展示标识
            item.showMore = false;
            return item;
          });
        }
      });
    },
    insertData(data) {
      let curItem = this.curItem.dataStrList[this.curWordIndex];
      curItem.value += "{" + data.name + "}";
      curItem.wordNum++;
      this.showWordModal = false;
      this.$refs.titleFormRef.validate(() => {});
    },
    formatData(titleItem) {
      let copyData = JSON.parse(JSON.stringify(titleItem));
      let titleData = {
        title_list: copyData.dataStrList.map((wordItem) => {
          let idArr = [];
          let matchRes = wordItem.value.match(/{(.*?)}/g); //['{xxx}', '{xxx}'] 格式
          if (matchRes) {
            matchRes.forEach((matchItem) => {
              let name = matchItem.replace(/^{|}$/g, "");
              let wordItem = this.wordList.find((item) => item.name === name);
              if (wordItem) {
                idArr.push(wordItem.creative_word_id);
              }
            });
          }
          return {
            title: wordItem.value,
            creative_word_ids: idArr.length > 0 ? idArr.join() : null,
          };
        }),
      };
      return {
        itemId: copyData.itemId,
        titlePkgName: copyData.titlePkgName,
        titleData: JSON.stringify(titleData),
      };
    },
    saveInStore() {
      let storeDataList = this.dataList.map((formItem) => {
        let formatobj = this.formatData(formItem);
        formatobj.title_data = formatobj.titleData;
        formatobj.name = formatobj.titlePkgName; //添加名字好回显
        delete formatobj.titlePkgName;
        delete formatobj.titleData;
        return formatobj;
      });
      this.$store.commit(
        "set_title_group_k",
        storeDataList.length ? storeDataList : null
      );
    },
    //保存到标题包
    saveCreativeTitle() {
      let data = this.formatData(this.curItem);
      saveCreativeTitle(data).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "标题包新建成功",
            type: "success",
          });
          this.saveInStore();
        }
      });
    },
    checkWordLength(dataStr, index) {
      let reg = /{(.*?)}/g;
      let matchRes = dataStr.match(reg);
      if (matchRes) {
        this.curItem.dataStrList[index].wordNum = matchRes.length;
      } else {
        this.curItem.dataStrList[index].wordNum = 0;
      }
      this.$refs.titleFormRef.validate(() => {});
    },
    editCreativeTitle(item) {
      this.curItem = item;
    },
    copyCreativeTitle(item) {
      if (this.dataList.length >= 10) {
        return;
      }
      let copyData = JSON.parse(JSON.stringify(item));
      copyData.itemId = Math.random();
      copyData.titlePkgName = copyData.titlePkgName += "_复制";
      this.dataList.push(copyData);
      this.saveInStore();
    },
    delCreativeTitle(delItem) {
      let delIndex = this.dataList.findIndex(
        (item) => item.itemId === delItem.itemId
      );
      this.dataList.splice(delIndex, 1);
      this.saveInStore();
    },
    checkData() {
      return new Promise((resolve, reject) => {
        if (this.dataList.length > 0) {
          let pass = true;
          for (let i = 0; i < this.dataList.length; i++) {
            let item = this.dataList[i];

            if (
              item.titlePkgName === "" ||
              item.dataStrList.length <= 0 ||
              item.dataStrList.some((item) => item.value === "")
            ) {
              pass = false;
              this.editCreativeTitle(item);
              this.$nextTick(() => {
                this.$refs.titleFormRef.validate(() => {});
              });
              break;
            }
          }
          if (pass) {
            this.saveInStore();
            resolve();
          } else {
            reject();
          }
        } else {
          reject();
        }
      });
    },
  },
  computed: {
    ...mapState({
      title_group: (state) => state.PromotionKuaishou.draft_ad.title_group,
    }),
  },
  watch: {
    //回显
    title_group(value) {
      if (value) {
        let formDataList = value.map(({ title_data, name, itemId }) => {
          let titelList = JSON.parse(title_data).title_list;
          return {
            itemId: itemId,
            titlePkgName: name ? name : "",
            dataStrList: titelList.map((wordItem) => {
              return {
                dataId: Math.random(),
                wordNum: wordItem.title.match(/{(.*?)}/g)
                  ? wordItem.title.match(/{(.*?)}/g).length
                  : 0, //动态词个数
                value: wordItem.title,
              };
            }),
          };
        });
        this.dataList = formDataList;
        if (this.dataList.length > 0) {
          this.editCreativeTitle(this.dataList[this.dataList.length - 1]);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.creative-title-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .num-text {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: normal;
      margin-left: 12px;
      position: relative;
      top: 2px;
    }
  }
  .btn-group {
    margin-left: auto;
    .center-line {
      border-left: 1px solid rgba(0, 0, 0, 0.25);
      margin: 0 20px;
    }
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 16px;
  }
  .word-modal-body {
    .modal-content {
      .wordlist-wrap {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    padding-bottom: 24px;
  }

  .add-modal-body {
    .modal-content {
      width: 500px;
      .word-list-wrap {
        max-height: 500px;
        min-height: 20px;
        overflow: auto;
        .form-wrap {
          border-radius: 2px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          margin-bottom: 12px;
          .form-header {
            height: 43px;
            background: rgba(0, 0, 0, 0.02);
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
            padding: 0 16px;
            display: flex;
            align-items: center;
            .header-text {
              color: rgba(0, 0, 0, 0.85);
              font-size: 14px;
              margin-right: auto;
            }
            .center-line {
              height: 17.5px;
              border-right: 1px solid rgba(0, 0, 0, 0.2);
              margin: 0 15px;
              display: inline-block;
            }
            .del-icon {
              color: rgba(24, 144, 255, 1);
              font-size: 15px;
              cursor: pointer;
            }
          }
          .form-content {
            /deep/ .el-textarea__inner {
              border: none;
              height: 60px;
            }
          }
        }
      }

      /deep/ .add-icon {
        height: 32px;
        width: 100%;
        color: rgba(24, 144, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(24, 144, 255, 1);
        margin-bottom: 24px;
      }
    }
    .footer-wrap {
      text-align: right;
      display: block;
      padding-bottom: 24px;
    }
  }
}
</style>